import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RealtimeApiService {

  constructor(private http: HttpClient) { }

  searchProducts( keyword: string, zipcode: string) {
    return this.http.get(
      `https://retailer-dot-covid-innovation-221486.appspot.com/products?keyword=${keyword.toLowerCase()}&zip=${zipcode}`
    );
  }

  searchStores(retailer: string, pid: string, zipcode: string) {
    return this.http.get(
      `https://retailer-dot-covid-innovation-221486.appspot.com/products/${retailer.toLowerCase()}/inventory/${pid}?zip=${zipcode}`
    );
  }
}
